import React, { Fragment } from "react";
import {
  List,
  Datagrid,
  Filter,
  EditButton,
  Button, useRecordContext,
  TextInput,
  TextField,
  FunctionField,
  ShowButton,
  useListContext,
  TopToolbar,
  DateInput
} from "react-admin";
import { OrderIDStatusSelectInput, BuymoteOrderIDTypeSelectInput } from '../../UI/Input/SelectInput'
const ListFilter = (props) => {
  const {

    setFilters,
    hideFilter
  } = useListContext();
  return (<Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <OrderIDStatusSelectInput label="Status" source="status" alwaysOn />
    <BuymoteOrderIDTypeSelectInput label="type" source="orderID_type" alwaysOn />
    <DateInput source="current_date" lable="Date" alwaysOn />

  </Filter>)
};



const BuymoteEduquestOrderIDList = ({ record, ...props }) => {

  return (
    <Fragment>
      <List
        {...props}
        title="Order ID's"
        bulkActionButtons={null}

        sort={{ field: "name", order: "ASC" }}

        filters={<ListFilter />}
      >
        <Datagrid >
          <TextField source="id" />
          <TextField source="order_id" label="OrderID" />
          <TextField source="orderID_type" label="Type" />
          <TextField source="profile_id" label="Profile ID" />
          <TextField source="verified_at" label="Verified At" />
          <TextField source="upload_at" label="Uploaded At" />
          <TextField source="actionby.name" label="Uploaded By" />
          <FunctionField source="status" label="Status" render={record => {
            if (record['status'] === 'Pending') {
              return (<Button style={{ color: 'orange', border: '1px solid' }} label="Pending" size="small"></Button>)
            } else if (record['status'] === 'Verified') {
              return (<Button style={{ color: 'green', border: '1px solid' }} label="Active" size="small"></Button>)
            }
          }} />

        </Datagrid>
      </List>

    </Fragment>
  );
};

export default BuymoteEduquestOrderIDList;
